(function() {
    window.recurpay = window.recurpay || {};
    window.recurpayScript = window.recurpayScript || {};
    //Append Script
    var initScript = function(url, callback) {
      var script = document.createElement("script");
      script.type = "text/javascript";
      if (script.readyState){
        script.onreadystatechange = function() {
          if (script.readyState == "loaded" || script.readyState == "complete") {
            script.onreadystatechange = null;
            callback();
          }
        };
      } else {
        script.onload = function() {
          callback();
        };
      }
      script.src = url;
      document.getElementsByTagName("head")[0].appendChild(script);
    };

    var recurpayHelperFunction = function($ = recurpayScript){
        var atcSelector = '[name="add"], [type=\"submit\"], button#AddToCart, button.gf_add-to-cart, button.gp-button-atc,.new-form-atc[data-add-to-cart]',
            atcFormSelector = 'form[action*="/cart/add"], form[action*="/cart/add.js"], form[id^="product_form_"], form[data-productid], form[action*="/cart/add"][data-js-product-form], form#AddToCartForm, #addToCartFormId1, form.product-form, #AddToCartForm_id, form[data-cart-submit="data-cart-submit"][data-productid], form.lh-product-form, form.shg-product-atc-btn-wrapper, form.shopify-product-form, product-form.product-form',
            buynowSelector = '.shopify-payment-button,.shopify-payment-button__button,#button-cart';

        recurpay.getProductHandle = function(href){
            if (typeof href === "undefined") {
                var href = window.location.href;
                href = href.replace("/products/products", "/products");
            }
            if (/\/products\/([^\?\/\n]+)/.test(href)){
                var found = href.match(/\/products\/([^\?\/\n]+)/);
                if (typeof found[1] !== "undefined") {
                    try {
                        return decodeURIComponent(found[1]).replace("#", "");
                    } catch (e) {
                        return found[1].replace("#", "");
                    }
                }
            }
            return false;
        }
        recurpay.logEvent = function(module_name,addon,type){
            $.ajax({
                url: recurpay.logURL,
                type: 'POST',
                async:true,
                dataType: 'json',
                data: {
                module:module_name,
                level: type,
                payload:{
                    store : '{{shop.permanent_domain}}',
                    remark: addon
                }
                },
                success: function(response) {
                console.log("event logged");
                }
            });
        }
        recurpay.calculatePrice = function(variant_id){
            var variant_json = {};
            var variant_price = 0;
            var productObj = {};
            if(variant_id !== undefined && variant_id !== null){
                variant_id = parseInt(variant_id);
                let variant_data = [];
                for(i=0 ; i< recurpay.productDatas.length; i++){
                variant_data.push(...recurpay.productDatas[i].product.variants.filter(function(searchId) {
                    return parseInt(searchId.id) == variant_id;
                }));
                }
        
                if(variant_data.length >=1){
                productObj.variant_price = variant_data[0].price;
                productObj.product_id = variant_data[0].product_id;
                }
            }
            else{
                productObj.variant_price = recurpay.productDatas[0].product.variants[0].price;
                productObj.product_id = recurpay.productDatas[0].product.id;
            }
            return productObj;
        }
        recurpay.handlePlanOnVariant = function(variant){
            let excludedPlans = [];
            var getVariantObj = recurpay.calculatePrice(variant);
            var getProductId = parseInt(getVariantObj.product_id);
            let variantId = variant;
            recurpay.globalPlanObjectArray.forEach(plan => {
                plan.products.forEach(product => {
                    if(product.excluded_variants && product.excluded_variants.length > 0){
                        product.excluded_variants.forEach(variant => {
                            if (variant.id == variantId) {
                                excludedPlans.push(plan.id);
                            }
                        });
                    }
                });
            });
            let $pdpWidgetSelector = $('.recurpay-pdp-widget[data-product-id="'+getProductId+'"]');
            let isExcluded = excludedPlans.length > 0;
            let shownOptionCount = 0;
            let previousSelectedPlanId = $pdpWidgetSelector.find(".recurpay__frequency_select").find("option:selected").attr("data-plan") || null;
            let encodedOptions = $pdpWidgetSelector.find(".recurpay__frequency_select").attr('data-original-options');
            if(encodedOptions){
                let originalOptions = decodeURIComponent(encodedOptions);
                $pdpWidgetSelector.find(".recurpay__frequency_select").html(originalOptions); 
            }
            $pdpWidgetSelector.find(".recurpay__frequency_select option").each(function(){
                let $this = $(this);
                var getPlanId = $this.attr("data-plan");
                if(isExcluded && excludedPlans.includes(parseInt(getPlanId))){
                    $this.remove();
                }
                else{
                    shownOptionCount++;
                }
            });
            if(shownOptionCount === 0){
                $pdpWidgetSelector.hide();
                if($pdpWidgetSelector.parents(atcFormSelector).find(atcSelector).hasClass("recurpay-hide")){
                    $pdpWidgetSelector.parents(atcFormSelector).find(atcSelector).removeClass("recurpay-hide");
                }
                if($pdpWidgetSelector.parents(atcFormSelector).find(buynowSelector).hasClass("recurpay-hide")){
                    $pdpWidgetSelector.parents(atcFormSelector).find(buynowSelector).removeClass("recurpay-hide");
                }
                $(document).find(".recurpay_plan_name").attr("name", "");
                $(document).find(".recurpay_plan_id").attr("name", "");
                $(document).find(".recurpay_purchase_data").attr("name", "");
                $(document).find(".recurpay_selling_plan_id").attr("name", "");
            }
            else{
                $pdpWidgetSelector.show();
                if($(document).find("[name='recurpay__group_main']:checked").val() == 'subscription'){
                    $pdpWidgetSelector.parents(atcFormSelector).find(atcSelector).addClass("recurpay-hide");
                    $pdpWidgetSelector.parents(atcFormSelector).find(buynowSelector).addClass("recurpay-hide");
                    $(document).find(".recurpay_plan_name").attr("name", "properties[Plan]");
                    $(document).find(".recurpay_plan_id").attr("name", "properties[_PlanId]");
                    $(document).find(".recurpay_purchase_data").attr("name", "properties[_PurchaseData]");
                    $(document).find(".recurpay_selling_plan_id").attr("name", "selling_plan");
                }

                let $select = $pdpWidgetSelector.find(".recurpay__frequency_select");
                let $matchedOption = previousSelectedPlanId? $select.find(`option[data-plan="${previousSelectedPlanId}"]`): null;
                if (!$matchedOption || !$matchedOption.length) {
                    $matchedOption = $select.find('option[data-recommended-frequency="true"]');
                    if(!$matchedOption.length) {
                      $matchedOption = $select.find("option").first();
                    }
                }
                if($matchedOption && $matchedOption.length) {
                    $matchedOption.prop("selected", true);
                    $select[0].dispatchEvent(new Event("change", { bubbles: true }));
                }
            }
        }
        recurpay.hexToRgbA = function(hex){
            var c;
            if(/^#([A-Fa-f0-9]{3}){1,2}$/.test(hex)){
                c=hex.substring(1).split('');
                if(c.length==3){
                    c=[c[0],c[0],c[1],c[1],c[2],c[2]];
                }
                c='0x'+c.join('');
                return'rgba('+[(c>>16)&255,(c>>8)&255,c&255].join(',')+',0.1)';
            }
            return'rgba(255, 255, 255, 0.1)';
        }
        recurpay.recurMoney = {
            formatPrice: function (price, convertCurrency) {
                if (typeof Shopify !== "undefined" && Shopify.hasOwnProperty("currency") && Shopify.currency.hasOwnProperty("rate")) {
                    var currency = Shopify.currency.active;
                    var exchangeRate = Shopify.currency.rate;
                    var moneyFormat = "{{amount}}" + currency;
                    var currencyFormat = "";
                    if (typeof convertCurrency === "undefined"){
                        convertCurrency = false;
                    }
                    if (convertCurrency && exchangeRate !== "1.0"){
                        price = this.convertMoney(price, exchangeRate, currency);
                    }
                    var bodyAttrMoneyFormat = $("body").attr("data-money-format");
                    if (currencyFormat !== "") {
                        moneyFormat = currencyFormat;
                    }
                    else {
                        if (typeof Shopify !== "undefined" && typeof Shopify.currency_settings !== "undefined" && typeof Shopify.currency_settings.money_format !== "undefined") {
                            moneyFormat = Shopify.currency_settings.money_format;
                        } else if (typeof window.money_format !== "undefined") {
                            moneyFormat = window.money_format;
                        } else if (typeof window.Theme !== "undefined" && typeof window.Theme.moneyFormat !== "undefined") {
                            moneyFormat = window.Theme.moneyFormat;
                        } else if (typeof window.theme !== "undefined" && typeof window.theme.moneyFormat !== "undefined") {
                            moneyFormat = window.theme.moneyFormat;
                        } else if (typeof window.theme !== "undefined" && typeof window.theme.money_format === "string") {
                            moneyFormat = window.theme.money_format;
                        } else if (typeof window.theme !== "undefined" && typeof window.theme.settings !== "undefined" && typeof window.theme.settings.moneyFormat !== "undefined") {
                            moneyFormat = theme.settings.moneyFormat;
                        } else if (typeof window.theme !== "undefined" && typeof window.theme.strings !== "undefined" && typeof window.theme.strings.moneyFormat === "string") {
                            moneyFormat = window.theme.strings.moneyFormat;
                        } else if (typeof window.Currency !== "undefined" && typeof window.Currency.money_format !== "undefined" && typeof window.Currency.money_format[currency] === "string") {
                            moneyFormat = window.Currency.money_format[currency];
                        } else if (typeof window.Currency !== "undefined" && typeof window.Currency.money_format === "string") {
                            moneyFormat = window.Currency.money_format;
                        } else if (typeof bodyAttrMoneyFormat !== "undefined" && typeof bodyAttrMoneyFormat === "string" && bodyAttrMoneyFormat !== "") {
                            moneyFormat = bodyAttrMoneyFormat;
                        } else if (typeof wsgMoneyFormat === "string"){
                            moneyFormat = wsgMoneyFormat;
                        } else if (typeof price_format === "string"){
                            moneyFormat = price_format;
                        } else {
                            price = price / 100;
                            return price.toLocaleString(undefined, { style: "currency", currency: currency || this.getDefaultCurrency() });
                        }
                  }
                  return this.formatMoney(price, moneyFormat, currency || this.getDefaultCurrency());
                }
                return "";
            },
            formatMoney: function (cents, format, fallbackCurrency, directionFor50) {
                if (typeof directionFor50 === "undefined") {
                    var directionFor50 = "up";
                }
                try {
                    if (typeof cents == "string") {
                        cents = cents.replace(".", "");
                    }
                    var value = "";
                    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
                    var formatString = format;
                    function defaultOption(opt, def) {
                        return typeof opt == "undefined" ? def : opt;
                    }
                    function formatWithDelimiters(number, precision, thousands, decimal, directionFor50) {
                        precision = defaultOption(precision, 2);
                        thousands = defaultOption(thousands, ",");
                        decimal = defaultOption(decimal, ".");
                        directionFor50 = defaultOption(directionFor50, "up");
                        if (isNaN(number) || number == null) {
                            return 0;
                        }
                        var originalNumber = number;
                        number = (number / 100.0).toFixed(precision);
                        if (directionFor50 === "down") {
                            if (originalNumber / 100 - number === -0.5) {
                                number -= 1;
                                number = number.toString();
                            }
                        }
                        var parts = number.split("."),
                            dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + thousands),
                            cents = parts[1] ? decimal + parts[1] : "";
                        return dollars + cents;
                    }
                    switch (formatString.match(placeholderRegex)[1]) {
                        case "amount":
                            value = formatWithDelimiters(cents, 2);
                            break;
                        case "amount_no_decimals":
                            value = formatWithDelimiters(cents, 0, ",", ".", directionFor50);
                            break;
                        case "amount_with_comma_separator":
                            value = formatWithDelimiters(cents, 2, ".", ",");
                            break;
                        case "amount_with_decimal_separator":
                            value = formatWithDelimiters(cents, 2, ",", ".");
                            break;
                        case "amount_no_decimals_with_comma_separator":
                            value = formatWithDelimiters(cents, 0, ".", ",", directionFor50);
                            break;
                        case "amount_no_decimals_with_space_separator":
                            value = formatWithDelimiters(cents, 0, " ", ",", directionFor50);
                            break;
                        case "amount_with_apostrophe_separator":
                            value = formatWithDelimiters(cents, 2, "'", ".");
                            break;
                    }
                    return formatString.replace(placeholderRegex, value);
                } catch (e) {
                    console.log(e.message);
                    price = cents / 100;
                    return price.toLocaleString(undefined, { style: "currency", currency: fallbackCurrency });
                }
            },
            convertMoney: function (value, rate, currency, round) {
                if (value <= 0) {
                    return 0;
                }
                value *= rate;
                var roundUp = ["USD", "CAD", "AUD", "NZD", "SGD", "HKD", "GBP"];
                var roundTo100 = ["JPY"];
                var roundTo95 = ["EUR"];
                if (round) {
                    if (roundUp.indexOf(currency) !== -1) {
                        value = Math.ceil(value);
                    } else if (roundTo100.indexOf(currency) !== -1) {
                        value = Math.ceil(value / 100) * 100;
                    } else if (roundTo95.indexOf(currency) !== -1) {
                        value = Math.ceil(value) - 0.05;
                    }
                }
                return value;
            }
          };
    }
    //Append jQuery if it is not there, then call to recurpaySubscription
    //Otherwise directly call to recurpaySubscription
    if((typeof(jQuery) == 'undefined') || (typeof(jQuery.ajax) == 'undefined')) {
      initScript('//ajax.googleapis.com/ajax/libs/jquery/3.6.0/jquery.min.js', function() {
        window.recurpayScript = jQuery.noConflict(true);
        recurpayHelperFunction(recurpayScript);
      });
    }
    else {
      window.recurpayScript = jQuery;
      recurpayHelperFunction(jQuery);
    }
})();
    
